<template>
	<b-modal
		ref="gitModal"
		id="confirm-dialog"
		:modal-class="theme"
		:title="title"
		hide-footer
		centered
		body-class="modal__confirm"
		:size="size"
	>
		<GitConfig @close="onClose" :type="type" :serviceName="serviceName" @resizeDialog="resize"/>
	</b-modal>
</template>

<script>
import GitConfig from './GitConfig';
import ThemeService from '../../services/theme';

export default {
	name: "GitConfigDialog",
	components: {
		GitConfig
	},
	data() {
		return {
			theme: null,
			type: null,
			serviceName: null,
			size: 'md'
		};
	},
	mounted() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		listenForThemeChanges: function () {
			ThemeService.instance().events.on('themechanged', () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
		onClose() {
			this.$refs.gitModal.hide();
		},
		show(type, serviceName) {
			this.size = 'md';
			this.type = type;
			this.serviceName = serviceName;
			this.$refs.gitModal.show();
		},
		resize(newSize) {
			this.size = newSize;
		}
	},
	computed: {
		title() {
			return this.type + ' configuration.';
		}
	}
};
</script>

<style>
</style>